<script lang="ts">
    import Stars from "./Stars.svelte"
    import { _ } from "svelte-i18n"

    export let product: Product
    let offset = ((product.averageRating + 0.5) % 1) * 100
</script>

<div class="row line">
    {#if product.amountOfRatings > 0}
        <Stars stars="{product.averageRating}" identifier="{product.id}" />
        <div class="rating">
            {product.amountOfRatings}
            {$_("ratings.customer-reviews")}
        </div>
    {/if}
</div>

<style lang="less">
    .row {
        height: 30px;
        width: 100%;
        margin: 0px;
        margin-bottom: 10px;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 10px;
        border-bottom: 1px dotted #c7c7c7;
        .rating {
            font-size: 0.7rem;
        }
    }
</style>
